import Lottie from 'react-lottie'
import successData from '../../assets/images/answer_success.json'
import errorData from '../../assets/images/answer_fail.json'
import { makeStyles } from '@mui/styles';
import { useMediaQuery } from '@mui/material';

const useStyles = makeStyles(() => ({
    validator: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        transform: 'translateY(-320px)',
        textAlign: 'center',
        zIndex: 9999,
    }
}))

interface QuestionValidatorProps {
    setSeeAnimation: (value: boolean) => void
    correct: boolean
}

export function QuestionValidator({ setSeeAnimation, correct }: QuestionValidatorProps): JSX.Element {
    const classes = useStyles()
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: correct ? successData : errorData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }
    const desktop = useMediaQuery('(min-width:481px)')
    return <div
        className={`${classes.validator} lottie-class`}
        style={{
            transform: desktop && 'translateY(-300%)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
        }}>
        <Lottie
            options={defaultOptions}
            height={100}
            width={100}
            eventListeners={[
                {
                    eventName: 'complete',
                    callback: () => setSeeAnimation(false),
                },
            ]}
        />
    </div>
}